import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = { class: "info-row" }
const _hoisted_3 = { class: "info-value" }
const _hoisted_4 = { class: "info-row" }
const _hoisted_5 = { class: "info-value" }
const _hoisted_6 = { class: "form-section" }
const _hoisted_7 = { class: "form-row" }
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "form-row" }
const _hoisted_10 = { class: "form-row" }
const _hoisted_11 = { class: "form-row" }
const _hoisted_12 = {
  key: 0,
  class: "pdf-preview"
}
const _hoisted_13 = ["src"]

import { ref, reactive, computed } from 'vue';
import YmdDateInput from '@/components/common/YmdDateInput.vue';
import axios from 'axios';
import { tokenManager } from '@/services/api';

interface Props {
  mCode?: string | number;
  memberName?: string;
  bizGubun?: string;
  year?: number;
  month?: number;
  dataCount?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonWageTransaction',
  props: {
    mCode: {},
    memberName: {},
    bizGubun: {},
    year: {},
    month: {},
    dataCount: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const dialog = ref(false);
const pdfDialog = ref(false);
const loading = ref(false);
const pdfData = ref<string | null>(null);

const form = reactive({
  writeDate: new Date().toISOString().split('T')[0],
  wageCount: 0,
  wageUnitPrice: 17000,
  wageTotalPrice: 0,
  wageBigo: ''
});

const pdfSrc = computed(() => {
  if (pdfData.value) {
    return `data:application/pdf;base64,${pdfData.value}`;
  }
  return '';
});

const formatNumber = (value: number) => {
  return value.toLocaleString();
};

const calculateTotal = () => {
  form.wageTotalPrice = (form.wageCount || 0) * (form.wageUnitPrice || 0);
};

const getAuthHeaders = () => {
  const token = tokenManager.getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const generatePdf = async () => {
  loading.value = true;
  try {
    const response = await axios.post('/api/common-wage/transaction-pdf', {
      mCode: props.mCode,
      memberName: props.memberName,
      year: props.year,
      month: props.month,
      bizGubun: props.bizGubun,
      writeDate: form.writeDate,
      wageCount: form.wageCount,
      wageUnitPrice: form.wageUnitPrice,
      wageBigo: form.wageBigo
    }, {
      headers: getAuthHeaders()
    });

    if (response.data.success) {
      pdfData.value = response.data.pdf;
      pdfDialog.value = true;
      dialog.value = false;
    } else {
      alert('PDF 생성에 실패했습니다.');
    }
  } catch (error) {
    console.error('거래명세서 PDF 생성 오류:', error);
    alert('PDF 생성 중 오류가 발생했습니다.');
  } finally {
    loading.value = false;
  }
};

const downloadPdf = () => {
  if (pdfData.value) {
    const link = document.createElement('a');
    link.href = `data:application/pdf;base64,${pdfData.value}`;
    link.download = `거래명세서_${props.memberName}_${props.year}${String(props.month).padStart(2, '0')}.pdf`;
    link.click();
  }
};

const openDialog = (count?: number) => {
  form.writeDate = new Date().toISOString().split('T')[0];
  form.wageCount = count || props.dataCount || 0;
  form.wageUnitPrice = 17000;
  form.wageBigo = '';
  calculateTotal();
  dialog.value = true;
};

const closeDialog = () => {
  dialog.value = false;
};

__expose({ openDialog });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialog).value = $event)),
      "max-width": "600"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "common-wage-transaction-modal" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_v_icon, {
                    color: "error",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("mdi-file-document-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "modal-title" }, "거래명세서 생성", -1))
                ]),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  onClick: closeDialog,
                  class: "close-btn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "modal-body" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "info-label" }, "대상 시설:", -1)),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(__props.memberName), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "info-label" }, "서비스 연월:", -1)),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(__props.year) + "년 " + _toDisplayString(__props.month) + "월", 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", null, "작성일자", -1)),
                    _createVNode(YmdDateInput, {
                      modelValue: form.writeDate,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.writeDate) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", null, "수량 (인원)", -1)),
                    _createVNode(_component_v_text_field, {
                      modelValue: form.wageCount,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.wageCount) = $event)),
                      modelModifiers: { number: true },
                      type: "number",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      onInput: calculateTotal
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", null, "단가", -1)),
                    _createVNode(_component_v_text_field, {
                      modelValue: form.wageUnitPrice,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.wageUnitPrice) = $event)),
                      modelModifiers: { number: true },
                      type: "number",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      onInput: calculateTotal
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", null, "총액", -1)),
                    _createVNode(_component_v_text_field, {
                      "model-value": formatNumber(form.wageTotalPrice),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      readonly: "",
                      class: "total-field"
                    }, null, 8, ["model-value"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", null, "비고", -1)),
                    _createVNode(_component_v_text_field, {
                      modelValue: form.wageBigo,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.wageBigo) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      placeholder: "비고 입력"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "modal-footer" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-cancel",
                  onClick: closeDialog
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode("취소", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-save",
                  onClick: generatePdf,
                  loading: loading.value,
                  disabled: !form.wageCount || form.wageCount <= 0
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode(" PDF 생성 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: pdfDialog.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((pdfDialog).value = $event)),
      "max-width": "900"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pdf-preview-modal" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-header" }, {
              default: _withCtx(() => [
                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "modal-title" }, "거래명세서 미리보기", -1)),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (pdfDialog.value = false)),
                  class: "close-btn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "modal-body" }, {
              default: _withCtx(() => [
                (pdfSrc.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("iframe", {
                        src: pdfSrc.value,
                        width: "100%",
                        height: "600",
                        frameborder: "0"
                      }, null, 8, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "modal-footer" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-close",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (pdfDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode("닫기", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-save",
                  onClick: downloadPdf
                }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode("다운로드", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})